import { createRequest, createUseRequest, createUseRequestMap } from '@/common/createRequest';
import { Model as ModalKapi } from '@/kus/kapi';
import { Model as ModalKapiTransaction } from '@/kus/kapiTransaction';
import { Model as ModalSwagger } from '@/kus/swagger';
import { Model as ModelMarketing } from '@/kus/marketing';
import { Model as ModelPriv } from '@/kus/ecomPriv';
import { Model as ModelEcomTradeC } from '@/kus/ecomTradeC';
import { getKrnDomain } from '@/common/api';
type Merge<F, S> = {
    [P in keyof S]: S[P];
} & {
    [P in keyof F as P extends keyof S ? never : P]: F[P];
};
export type Model = ModalKapiTransaction & ModelMarketing & ModelPriv & Merge<ModalSwagger, ModelEcomTradeC> & ModalKapi;
export const http = createRequest<Model>(
    {
        baseURL: getKrnDomain(),
    },
    {
        response: (res, extra) => {
            return res;
        },
    },
);
export const useHttp = createUseRequest<Model>(http);
export const useHttpMap = createUseRequestMap<Model>(useHttp);
